<template>
  <div
    class="header-banner relative"
    :class="{ 'about-us': $route.params.path1 == 'about-us' }"
  >
    <BreadCrumb :header_banner="true" />

    <picture>
      <source
        media="(max-width: 767px)"
        :srcset="_.get(content, `images.devices.mobile`)"
      />
      <source
        media="(max-width: 1023px)"
        :srcset="_.get(content, `images.devices.tablet`)"
      />
      <img :src="_.get(content, `images.devices.desktop`)" alt />
    </picture>

    <div class="header-banner__layer"></div>
    <div class="header-banner__content container">
      <div class="title font-34 uppercase bold">{{ content.title }}</div>
      <div class="teaser light">{{ content.teaser }}</div>
    </div>
  </div>
</template>

<script>
import BreadCrumb from "@/components/modules/BreadCrumb";
export default {
  props: ["contentData"],
  components: { BreadCrumb },
  computed: {
    content() {
      return {
        images: _.get(this.$store.state.main, "selected_menu.media.cover"),
        title: _.get(this.$store.state.main, "selected_menu.title"),
        teaser: _.get(this.$store.state.main, "selected_menu.teaser")
      };
    },
    offersCount() {}
  }
};
</script>

<style lang="scss" scoped>
.header-banner {
  position: relative;
  width: 100%;
  height: 377px;
  display: flex;
  align-items: end;
  top: 195px;

  &.about-us {
    top: 94px;
    @media (max-width: 1023px) {
      top: 64px;
    }
  }
  @media (max-width: 1439px) {
    top: 165px;
  }
  @media (max-width: 1365px) {
    height: 233px;
  }
  @media (max-width: 1023px) {
    top: 64px;
  }
  picture {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  img {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 1;
  }

  &:after {
    position: absolute;
    content: "";
    bottom: -3px;
    width: 100%;
    height: 3px;
    background: linear-gradient(
      to right,
      #40adec 0%,
      #426ab3 20%,
      #3269e5 30%,
      #ffcb05 40%,
      #ffc900 50%,
      #ffc900 50%,
      #e11f26 60%,
      #e50b09 100%
    );
  }

  &__layer {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 2;
    background: linear-gradient(
      to top,
      rgba(26, 26, 26, 0.7) 0%,
      rgba(26, 26, 26, 0) 100%
    );
  }

  &__content {
    position: relative;
    bottom: 44px;
    z-index: 3;
    @media (max-width: 767px) {
      bottom: 60px;
    }
    .title {
      @media (max-width: 767px) {
        font-size: 21px;
      }
    }
    .title,
    .teaser {
      color: $white;
    }
  }
  @media (min-width: 0px) {
    height: auto;
    picture,
    &__layer {
      top: 0;
      left: 0;
    }
    &__content {
      position: absolute;
      z-index: 5;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  @media (min-width: 1024px) {
    padding-bottom: calc(100% / 5.09283819629);
  }

  @media (max-width: 1023px) {
    padding-bottom: calc(100% / 1.29613733906);
  }
}
</style>
